exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".styles__socialNetworks___3J7C3{display:flex;flex-direction:row;justify-content:center;align-items:center;align-content:center}.styles__socialNetworksImg___2t6lP{margin-right:19px;cursor:pointer}\n", "", {"version":3,"sources":["/home/yvpv/boosters.pro/frontend/src/components/utils/social/styles.scss"],"names":[],"mappings":"AAAA,gCAAgB,aAAa,mBAAmB,uBAAuB,mBAAmB,oBAAoB,CAAC,mCAAmB,kBAAkB,cAAc,CAAC","file":"styles.scss","sourcesContent":[".socialNetworks{display:flex;flex-direction:row;justify-content:center;align-items:center;align-content:center}.socialNetworksImg{margin-right:19px;cursor:pointer}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"socialNetworks": "styles__socialNetworks___3J7C3",
	"socialNetworksImg": "styles__socialNetworksImg___2t6lP"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-oneOf-6-2!./node_modules/sass-loader/dist/cjs.js!./src/components/utils/social/styles.scss
// module id = ./node_modules/css-loader/index.js??ref--1-oneOf-6-2!./node_modules/sass-loader/dist/cjs.js!./src/components/utils/social/styles.scss
// module chunks = 16